import { Component, Input, OnInit } from "@angular/core"
import { StudentSignupModalComponent } from "../../modals/student-signup-modal/student-signup-modal.component"
import { StudentLoginModalComponent } from "../../modals/student-login-modal/student-login-modal.component"
import { ModalService } from "../../modal/modal.service"
import { WindowSizeService } from "../../../services/window-size.service"
import { EduComponent } from "../../../utils/eduComponent"
import { AuthModalComponent } from "../../modals/auth-modal/auth-modal.component"
import { Router } from "@angular/router"

/**
 * Opens up modals for Sign up/ Sign in functionality
 */
@Component({
    selector: "app-register",
    templateUrl: "./register.component.html",
    styleUrls: ["./register.component.scss"],
})
export class RegisterComponent extends EduComponent implements OnInit {
    @Input()
    nextURL: string | null = null

    @Input()
    isStudent = false

    @Input()
    buttonLabelText: string | null = null

    buttonLabel: string = ""
    isTablet: boolean

    constructor(
        private modalService: ModalService,
        private windowSizeService: WindowSizeService,
        private router: Router
    ) {
        super()
    }

    ngOnInit(): void {
        this.addSub(
            this.windowSizeService.resize.subscribe((obs) => {
                this.buttonLabel =
                    (obs.isSmallDesktop && !obs.isTablet && "Sign up") || "Sign up for free!"
                this.isTablet = obs.isTablet
            })
        )

        this.buttonLabel =
            (this.windowSizeService.isSmallDesktop &&
                !this.windowSizeService.isTablet &&
                "Sign up") ||
            "Sign up for free!"

        this.isTablet = this.windowSizeService.isTablet
    }

    openSignInModal(): void {
        this.isStudent ? this.openStudentSignIn() : this.openTeacherSignIn()
    }

    openSignUpModal(): void {
        this.isStudent ? this.openStudentSignUp() : this.goToSignUpPage()
    }

    private goToSignUpPage(): void {
        this.router.navigate(["/signup"])
    }

    private openStudentSignUp(): void {
        this.modalService.open(StudentSignupModalComponent, { size: "lg" })
    }

    private openStudentSignIn(): void {
        this.modalService.open(StudentLoginModalComponent, {
            data: {
                nextURL: this.nextURL,
            },
        })
    }

    private openTeacherSignIn() {
        this.modalService.open(AuthModalComponent, {
            data: {
                nextURL: this.nextURL,
            },
        })
    }
}
